import script from "./foot-bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./foot-bottom.vue?vue&type=script&setup=true&lang=js"

import "./foot-bottom.vue?vue&type=style&index=0&id=791ae71c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791ae71c"]])

export default __exports__